<template>
  <div class="doc-layout">
    <div id="lbs-header" />
    <div class="doc-container">
      <div>
        <div class="sidebar-container">
          <div
            class="expand-btn"
            :class="{ collapsed: !isExpanded }"
            @click="toggleExpanded"
          >
            <ChevronLeftDoubleIcon
              :class="{ 'arrow-icon': !isExpanded }"
              size="18"
            />
          </div>
          <div
            :class="['sidebar-wrapper', !isExpanded ? 'sidebar-collapsed': '']"
            :style="{ width: sidebarWidth + 'px' }"
          >
            <slot
              name="sidebar"
            />
          </div>
          <div
            class="resizer"
            @mousedown="startResize"
          />
        </div>
      </div>
      <div class="content-container">
        <div class="doc-body">
          <slot name="doc-body" />
        </div>
        <div class="right-body">
          <slot name="right-body" />
        </div>
      </div>
    </div>
    <div id="lbs-footer" />
  </div>
</template>
<script>
import { ChevronLeftDoubleIcon } from 'tdesign-icons-vue';
const DEFAULT_SIDEBAR_WIDTH = 272;
const MIN_SIDEBAR_WIDTH = 272;
const MAX_SIDEBAR_WIDTH = 480;


export default {
  name: 'DocLayout',
  components: {
    ChevronLeftDoubleIcon
  },
  props: {
    minWidth: {
      type: Number,
      default: MIN_SIDEBAR_WIDTH
    },
    maxWidth: {
      type: Number,
      default: MAX_SIDEBAR_WIDTH
    },
  },
  data() {
    return {
      isExpanded: true,
      sidebarWidth: DEFAULT_SIDEBAR_WIDTH,
    };
  },
  methods: {
    toggleExpanded() {
      this.isExpanded = !this.isExpanded;
    },
    startResize(event) {
      const initialX = event.clientX;
      const initialWidth = this.sidebarWidth;

      const onMouseMove = (e) => {
        const newWidth = initialWidth + (e.clientX - initialX);
        if (newWidth >= this.minWidth && newWidth <= this.maxWidth) {
          this.sidebarWidth = newWidth;
        }
      };

      const onMouseUp = () => {
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
      };

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    }
  }
};
</script>
<style lang="less" scoped>

.doc-layout {
  #lbs-header {
    position: fixed;
    height: 56px;
    border-bottom: 1px solid #E9EDF3;
    top: 0;
    left: 0;
    width: 100%;
    background: #fff;
    z-index: 9999;
  }
  height: 100vh;
  .doc-container {
    padding: 56px 0 0;
    position: relative;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    .sidebar-container {
      padding-top: 24px;
      // padding-bottom: 16px;
      height: calc(100vh - 56px);
      // overflow: hidden;
      position: sticky;
      left: 0;
      top: 56px;
      box-sizing: border-box;
      border-right: 1px solid rgba(207, 213, 221, 0.30);
      .sidebar-wrapper {
        // width: 272px;
        // min-width: 200px;
        height: 100%;
        &.sidebar-collapsed {
          display: none;
        }
      }
      .resizer {
        position: absolute;
        top: 0;
        right: -1px;
        width: 3px;
        height: 100%;
        cursor: url('./img/resizer.png') 8 8,ew-resize;
        background-color: transparent;
        border-right: 1px solid rgba(207, 213, 221, 0.30);
        z-index: 1;
      }
      .expand-btn {
        position: absolute;
        top: 62px;
        right: -16px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background-color: #fff;
        color: rgba(15, 24, 41, 0.5);
        border: 1px solid rgba(208, 213, 220, 0.3);
        box-shadow: 0px 13px 25px rgba(8, 20, 41, 0.05), 0px 1px 3px rgba(8, 20, 41, 0.03);
        transition: all 0.3s ease;
        cursor: pointer;
        z-index: 2;
        &:hover {
          color: rgba(0, 0, 0, 0.9);
        }
        &.collapsed {
          transition: all 0.3s ease;
          right: -30px;
          border-radius: 0 50% 50% 0;

          .arrow-icon {
            transform: rotate(180deg);
          }
        }
      }
    }
    .content-container {
      display: flex;
      flex: 1 1;
      gap: 32px;
      padding: 0 32px;
      justify-content: center;
      box-sizing: border-box;
      .doc-body {
        padding-top: 24px;
        padding-bottom: 80px;
        width: 936px;
        box-sizing: border-box;
      }
      .right-body {
        padding-top: 70px;
        width: 224px;
        position: sticky;
        top: 56px;
        right: 0;
        align-self: flex-start;
        box-sizing: border-box;
        height: calc(100vh - 56px);
        background: #fff;
      }
    }
  }
}
</style>
